// Shared metadata about the four map tools, used by the save layer and the
// "My Maps" list. `route` is where Reopen sends the user (with ?open=<id>);
// `label` is the leading breadcrumb word shown in the list.
export const MAP_KINDS = {
    shaper: { label: 'Shaped', route: '/photo-shaper' },
    travel: { label: 'Travel', route: '/travel-maps' },
    trail: { label: 'Trail', route: '/trail-maps' },
    roadtrip: { label: 'Road Trip', route: '/road-trips' },
};

// Query param a tool reads on boot to reopen a saved map. Deliberately NOT
// `?map=` — the Travel tool already uses `?map=` for the region selection.
export const REOPEN_PARAM = 'open';

// Build the Reopen URL for a saved map record.
export const reopenUrl = (type, id) => {
    const kind = MAP_KINDS[type];
    const route = kind ? kind.route : '/';
    return `${route}?${REOPEN_PARAM}=${encodeURIComponent(id)}`;
};
